import React from 'react'
import PropTypes from 'prop-types'

// Labelled <select>; `placeholder` shows only while the value is empty and cannot be re-picked.

// The magic network's `kind: 'header'` nodes label the options after them, so they become <optgroup>s.
const optionGroups = (options) => (options || []).reduce((groups, option) => {
  if (option.kind === 'header') {
    groups.push({ key: `group-${option.id}`, label: option.name, items: [] })
    return groups
  }
  const current = groups[groups.length - 1]
  if (current) { current.items.push(option) } else {
    groups.push({ key: `group-${option.id}`, label: null, items: [ option ] })
  }
  return groups
  // A header the traversal left with nothing under it would render as an empty group.
}, []).filter((group) => group.items.length > 0)

const FieldSelect = ({
  id,
  label,
  value,
  onChange,
  options = [],
  disabled = false,
  placeholder,
}) => {
  // Normalise first: testing the raw value left an undefined select showing its first real option.
  const selectValue = value ?? ''

  return (
    <div className="gl-field">
      <label className="gl-field-label" htmlFor={id}>{label}</label>
      <select
        id={id}
        className="gl-field-select"
        value={selectValue}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
      >
        {placeholder && selectValue === '' && (
          <option value="" disabled>{placeholder}</option>
        )}
        {optionGroups(options).map((group) => (
          group.label
            ? (
              <optgroup key={group.key} label={group.label}>
                {group.items.map((option) => (
                  <option key={option.id} value={option.id}>{option.name}</option>
                ))}
              </optgroup>
            )
            : group.items.map((option) => (
              <option key={option.id} value={option.id}>{option.name}</option>
            ))
        ))}
      </select>
    </div>
  )
}

FieldSelect.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  onChange: PropTypes.func.isRequired,
  // A `kind: 'header'` entry opens an <optgroup> over the options that follow it.
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    name: PropTypes.node,
    kind: PropTypes.string,
  })),
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
}

export default FieldSelect
